import React from 'react';
import { StyleSheet, Switch } from 'react-native';

import { Color, CommonProperties, CommonStyles } from '../styles';
import BaseText from './BaseText';
import RowView from './RowView';

const SwitchWithLabel = ({ left, border, label, value, onChange }) => {
  if (left) {
    return <SwitchWithLeftLabel value={value} onChange={onChange} label={label} />;
  }

  return (
    <RowView
      style={[
        styles.switchContainer,
        { borderBottomColor: border ? 'rgba(0,0,0,.2)' : 'transparent' },
      ]}
    >
      <BaseText>{label}</BaseText>
      <Switch
        value={value}
        thumbColor={value ? Color.primary : 'rgb(180,180,180)'}
        trackColor={{ true: Color.primary, false: 'rgba(0,0,0,.2)' }}
        onValueChange={onChange}
      />
    </RowView>
  );
};

const SwitchWithLeftLabel = ({ value, onChange, label }) => {
  return (
    <RowView style={styles.switchContainer}>
      <Switch value={value} onValueChange={onChange} />
      <BaseText style={[CommonStyles.ml5, CommonStyles.flex1]}>{label}</BaseText>
    </RowView>
  );
};

const styles = StyleSheet.create({
  switchContainer: {
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottomWidth: 0.5,
    borderColor: 'transparent',
    ...CommonProperties.py3,
  },
});

export default SwitchWithLabel;
